import React, { useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { addDays } from "date-fns";
import { enUS } from "date-fns/locale"; // ✅ locale import
import { Box, Paper } from "@mui/material";

const CustomStaticDateRangePicker = ({ value, onChange, sx = {} }) => {
  const [state, setState] = useState([
    {
      startDate: value?.[0] || new Date(),
      endDate: value?.[1] || addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const handleChange = (item) => {
    setState([item.selection]);
    if (onChange) {
      onChange([item.selection.startDate, item.selection.endDate]);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        ...sx,
      }}
    >
      <Box
        sx={{
          "& .rdrDateRangePickerWrapper": {
            fontFamily: "inherit",
          },
          "& .rdrDefinedRangesWrapper": {
            display: "none",
          },

          // ✅ Selected day background color
          "& .rdrDayNumber span": {
            "&:hover": {
              background: "#4caf50 !important", // green hover
            },
          },
          "& .rdrDayToday .rdrDayNumber span:after": {
            background: "#4caf50 !important", // today's indicator
          },

          // ✅ Selected range green
          "& .rdrInRange": {
            background: "#a5d6a7 !important", // light green
          },
          "& .rdrStartEdge, & .rdrEndEdge": {
            background: "#4caf50 !important", // dark green for start/end
          },
          "& .rdrDayStartPreview, & .rdrDayEndPreview, & .rdrDayInPreview": {
            border: "1px solid #4caf50 !important", // preview border
          },
        }}
      >
        <DateRangePicker
          onChange={handleChange}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          ranges={state}
          direction="horizontal"
          locale={enUS} // ✅ add this
          width="100%"
        />
      </Box>
    </Paper>
  );
};

export default CustomStaticDateRangePicker;
